import styles from './BookedState.module.scss';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  InlineNotification,
  NotificationType,
} from '@spotted-zebra-uk/ui-components';
import { BookingResultType } from '../../api/bookingApi.types';
import { fetchCalendarFile } from '../../api/bookingOperations';
import { saveCalendarFile } from './saveCalendarFile';

interface CalendarDownloadProps {
  token: string;
  /** True when the calendar file is this interview's only calendar entry. */
  offered: boolean;
}

/**
 * The calendar entry: a download when the file is the candidate's only entry,
 * otherwise a line saying the invitation has been sent to their email.
 */
const CalendarDownload: FC<CalendarDownloadProps> = ({ token, offered }) => {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState(false);

  if (!offered) {
    return <p className={styles.note}>{t('publicScheduling.calendarViaOutlook')}</p>;
  }

  const download = async () => {
    setBusy(true);
    setFailed(false);
    try {
      const call = await fetchCalendarFile(token);
      if (call.ok && call.result.__typename === BookingResultType.CALENDAR_FILE_CONTENT) {
        saveCalendarFile(call.result);
      } else {
        setFailed(true);
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={styles.download}>
      <Button variant="secondary" size="medium" loading={busy} onClick={download}>
        {t('publicScheduling.calendarDownload')}
      </Button>
      {failed && (
        <InlineNotification notificationType={NotificationType.ERROR}>
          <p>{t('publicScheduling.calendarDownloadFailed')}</p>
        </InlineNotification>
      )}
    </div>
  );
};

export default CalendarDownload;
